import React, { useEffect } from "react";
import "react-icons/fc";
import { motion, useAnimation } from "framer-motion";
import {
  FcBriefcase,
  FcCollaboration,
  FcGraduationCap,
  FcReading,
  FcCircuit,
} from "react-icons/fc";
import { box1, container, leftContent } from "../data/anim";
import { useInView } from "react-intersection-observer";

const About = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
  });
  const animation = useAnimation();

  useEffect(() => {
    if (inView) {
      animation.start({
        scale: 1,
        transition: {
          type: "spring",
          duration: 1,
          bounce: 0.3,
        },
      });

      //   animation2.start({
      //     scale: 0,
      //   });
    } else {
      // ref1.textContent = 0;
      animation.start({
        scale: 0,
      });
    }
  }, [inView, animation]);
  return (
    <motion.div ref={ref} className="title-container">
      <motion.h2 animate={animation} className="title">
        About Me
      </motion.h2>

      <div className="about-container">
        {inView && (
          <div className="extended-container">
            <motion.div
              variants={leftContent}
              initial="hidden"
              animate="visible"
              className="about"
            >
              <div className="content">
                <h1>Mabuhay!</h1>
                <p className="about-text">
                  I'm Jade Kenneth, looking for a <span>position</span> that
                  will
                  <span> improve</span> and start my <span>career</span> as a
                  web developer. I graduated at Visayas State University with a
                  degree of Bachelor of Science in Computer Science. I've been
                  spending this pandemic
                  <span> developing </span>and <span>learning </span> about web
                  development.
                </p>
                <button>
                  <a
                    href="https://drive.google.com/file/d/1SlKfR4LQJCsKVmLfrT_QJpGD6RCkepuI/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "white" }}
                  >
                    Download Resume
                  </a>
                </button>
              </div>
            </motion.div>
            <motion.div
              variants={container}
              initial="hidden"
              animate="visible"
              className="journey"
            >
              <motion.div variants={box1} className="org">
                <FcCollaboration className="icons" />

                <div className="content">
                  <h5>2015-2020</h5>
                  <h4>
                    Computer Science Student Society Organization (CS
                    <sup>3</sup>)
                  </h4>
                  <p>
                    An active member of VSU organization for computer science
                    student.
                  </p>
                </div>
              </motion.div>
              <motion.div variants={box1} className="workexp">
                <FcBriefcase className="icons" />

                <div className="content">
                  <h5>2017-2020</h5>
                  <h4>VSU Part-time Staff</h4>
                  <p>Student admission and encoder</p>
                </div>
              </motion.div>
              <motion.div variants={box1} className="college">
                <FcCircuit className="icons" />

                <div className="content">
                  <h5>2019-2020</h5>
                  <h4>A 2D Educational Adventure Game Based on Android</h4>
                  <p>Undergraduate Thesis</p>
                </div>
              </motion.div>
              <motion.div variants={box1} className="college">
                <FcGraduationCap className="icons" />

                <div className="content">
                  <h5>2015-2020</h5>
                  <h4>Visayas State University</h4>
                  <p>Bachelor of Science in Computer Science</p>
                </div>
              </motion.div>

              <motion.div variants={box1} className="college">
                <FcReading className="icons" />

                <div className="content">
                  <h5>2021-Present</h5>
                  <h4>Learning web development</h4>
                  <p>
                    Web fundamental, responsive design, web structure, web
                    security etc.
                  </p>
                </div>
              </motion.div>
              <motion.div variants={box1} className="workexp">
                <FcBriefcase className="icons" />
                <div className="content">
                  <h5>2021-Present</h5>
                  <h4>Freelancer</h4>
                  <p>Web developer</p>
                </div>
              </motion.div>
            </motion.div>{" "}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default About;
